import { render, staticRenderFns } from "./operationsconsume.vue?vue&type=template&id=de38b134&"
import script from "./operationsconsume.vue?vue&type=script&lang=js&"
export * from "./operationsconsume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports